<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between align-center" style="width:100%">
          <h3>Unverified Doctors</h3>
          <v-btn text color="rgb(0,170,221)" @click="getData">Refresh</v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-data-table fixed-header sort-by="registeredOn" sort-desc height="400" :headers="headers" :items="data" :loading="loading">
              <template
              v-slot:item.registeredOn="{ item }"
            >{{ convertDateWithHour(item.registeredOn) }}</template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
export default {
  created() {
    this.getData();
  },

  data() {
    return {
      loading: false,
      headers: [
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Username",
          value: "username"
        },
        {
          text: "Registered",
          value: "registeredOn"
        },
        {
            text: 'Doctor type',
            value: 'doctorTypeName'
        },
        {
            text: 'Medical association',
            value: 'greekMedicalAssociationName'
        },
        {
            text: 'Medical Assoc. Id',
            value: 'idNumber'
        },
        {
          text: "Municipality",
          value: "currentMunicipalityName"
        },
        {
          text: "Prefecture",
          value: "currentPrefectureName"
        }
      ],
      data: []
    };
  },

  methods: {
    getData() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}admin/notverifiedDoctors`)
        .then(res => {
          console.log(res);
          this.data = res.data;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    convertDateWithHour(date) {
      if (!!!date) return "";
      return moment(moment.utc(date).toDate())
        .local()
        .format("DD/MM HH:mm");
    }
  }
};
</script>